import request from '@/utils/http.js';
import env, { roomApiList } from '@/request/env';


/**
 * 设置房间观看端布局/清晰度
 * */
function setStream(params = {}) {
  return request({
    url: '/v3/interacts/room/set-stream',
    method: 'POST',
    data: params
  });
}
function getGeneralConfig(params = {}) {
  const url = '/v3/interacts/general-config/info';
  return request({
    url,
    method: 'GET',
    params
  });
}
//设置直播间内配置信息
function setInfoInWebinar(params = {}) {
  const url = '/v3/interacts/general-config/set-info-in-webinar';
  return request({
    url,
    method: 'POST',
    data: params
  });
}
//获取直播间内配置信息
function getInfoInWebinar(params = {}) {
  const url = '/v3/interacts/general-config/get-info-by-webinar-id';
  return request({
    url,
    method: 'GET',
    params
  });
}
export default {
  setStream,
  getGeneralConfig,
  setInfoInWebinar,
  getInfoInWebinar
};
